import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 5px;
`;

export const Title = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
`;
export const Subtitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  opacity: 0.9;
  line-height: 20px; /* 125% */
`;
export const ProgressNumber = styled.span`
  color: #fff;
  text-align: right;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
`;
export const SubtitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const ProgressBar = styled.div`
  border-radius: 100px;
  background: #18181b;
  width: 100%;
  height: 5px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const Progress = styled.div`
  border-radius: 100px;
  background: #4c9cfe;
  width: ${(props) => (props.$width ? props.$width : "0%")};
  height: 5px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 2;
`;
